import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../services/login.service';
import { UrlParamsService } from '../../services/url-params.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  providers: [LoginService, UrlParamsService]
})
export class SetPasswordComponent implements OnInit, OnDestroy {

  private _userSubscription: Subscription;
  private _userStoreSubscription: Subscription;
  private _resetPasswordSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _setPasswordSubscription: Subscription;

  private _userEmail;

  public passwordValues: any = {
    password1: '',
    password2: ''
  };
  public passwordMatch: Boolean = true;
  public routeParamsSubscription: Subscription;
  public user: any;
  public userTokenValue: string;
  public showLoader: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  showPassword: { [key: string]: boolean } = {
    password: false,
    confirmPassword: false
  };

  public passwordStrenghMessage = 'Your password needs to contain:<br>One capital letter<br>' +
    'One special character<br>One lowercase letter<br>One number<br>8 characters minimum<br>' +
    'Special characters allowed include: @ # $ % ^ *';

  constructor(
    private _appStore: Store<AppState>,
    private _urlParamsService: UrlParamsService,
    private _loginService: LoginService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _copyService: CopyService,
    private _errorService: ErrorHandler
  ) { }

  ngOnInit() {

    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

      })

    this._userStoreSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {

        if (user.userDetails.userEmail === '') {
          this._router.navigate(['login']);
          return;
        }

        if (Object.keys(user.userDetails.userEmailToken).length === 0) {
          return;
        } else {
          this._userEmail = user.userDetails.userEmailToken.emailAddress;
          this.userTokenValue = user.userDetails.userEmailToken.token;
        }
      });

    this._resetPasswordSubscription = this._loginService.resetPasswordSubject$
      .subscribe(res => {

        if (res.error) {
          this.showLoader = false;
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL_TOKEN_VALID', payload: false });
          return;
        }
        const encodedPassword = encodeURIComponent(this.passwordValues.password1);
        const params = 'grant_type=password&username=' + encodeURIComponent(this._userEmail) + '&password=' + encodedPassword;
        const storeCookie = true;
        const isGuest = false;
        // this._loginService.getToken(params, storeCookie, isGuest, this._userEmail);
        // this._loginService.userHasPassword();
        const data = {
          text: "Password set successfully!",
          type: "info",
          icon: "alert",
          sticky: false,
        };
        this._errorService.handleCustomInfo(data);
        this._router.navigate(['login']);
      },
        err => console.log(err));

    this._userSubscription = this._loginService.userSubject$
      .subscribe(user => {
        if (user.error) {
          this.handleError();
          return;
        }

        this._appStore.dispatch({ type: 'USER_ACCOUNT_UPDATE_STATUS', payload: true });
        this._router.navigate(['my-account/home']);
      },
        err => console.log(err));

    this._setPasswordSubscription = this._loginService.setPasswordSubject$
      .subscribe(res => {

        if (res.error) {
          this.showLoader = false;
          return;
        }

        const data = {
          text: "Password set successfully!",
          type: "info",
          icon: "alert",
          sticky: false,
        };
        this._errorService.handleCustomInfo(data);
        this._router.navigate(["login"]);
      })
  }

  togglePasswordVisibility(field: string): void {
    this.showPassword[field] = !this.showPassword[field];
  }
  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Password',
      ['setPassword']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleError() {
    this.showLoader = false;
    this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL_TOKEN_VALID', payload: false });
    setTimeout(() => {
      this._router.navigate(['validate-email']);
    }, 2500);
  }

  handleSubmitResetPassword(value, e) {
    this.passwordsEqual();
    e.preventDefault();

    if (this.passwordMatch) {
      this.showLoader = true;

      this.passwordValues = {
        password1: value.Password,
        password2: value.PasswordVerify
      };

      this.postPasswordChange();
    }

  }

  passwordsEqual() {
    let isMatch;

    if (this.passwordValues.password1 === this.passwordValues.password2) {
      isMatch = true;
    } else {
      isMatch = false;
    }

    this.passwordMatch = isMatch;
  }

  postPasswordChange() {

    if (this.userTokenValue) {
      this._loginService.resetPassword(this.passwordValues.password1, this.userTokenValue);
    } else {
      const email = this.getState(this._appStore).userReducer.userDetails.userEmail;
      const userToken = this.getState(this._appStore).userReducer.userDetails.setPasswordUserToken;
      const password = btoa(this.passwordValues.password1);
      this._loginService.setPassword(
        email,
        password,
        'mmb',
        userToken
      );
    }
  }

  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._resetPasswordSubscription.unsubscribe();
    this._userStoreSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    if (this._setPasswordSubscription) { this._setPasswordSubscription.unsubscribe(); }
  }

}
